import LegalLayout, { H } from "../../components/LegalLayout";

export default function Privacidad() {
  return (
    <LegalLayout title="Política de Privacidad" updated="Junio 2026">
      <p>
        En cumplimiento del Reglamento (UE) 2016/679 General de Protección de Datos (RGPD) y de la Ley Orgánica
        3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales
        (LOPDGDD), se informa a los usuarios de JordyBT_Fitness — Elite Coaching sobre el tratamiento de sus datos
        personales.
      </p>

      <H>1. Responsable del tratamiento</H>
      <p>
        Responsable: Jordi Betoret (JordyBT_Fitness — Elite Coaching). Los datos de contacto del responsable se
        facilitarán a través de los canales habilitados en esta web. Para cualquier consulta relativa a la
        protección de datos, el usuario puede dirigirse al responsable mediante el formulario de contacto.
      </p>

      <H>2. Finalidad del tratamiento</H>
      <p>
        Los datos personales que nos facilites a través del formulario de solicitud (nombre, email, teléfono,
        Instagram, edad, sexo, peso, altura, objetivos y respuestas de cualificación) serán tratados con las
        siguientes finalidades:
      </p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Gestionar tu solicitud de valoración gratuita y la reserva de la llamada.</li>
        <li>Contactarte para prestarte información sobre el programa Elite Coaching.</li>
        <li>Realizar un seguimiento comercial de tu solicitud.</li>
      </ul>

      <H>3. Legitimación</H>
      <p>
        La base legal para el tratamiento de tus datos es el consentimiento del interesado, prestado al marcar la
        casilla de aceptación del formulario, así como la aplicación de medidas precontractuales a petición del
        interesado.
      </p>

      <H>4. Conservación de los datos</H>
      <p>
        Los datos se conservarán mientras exista interés mutuo para mantener la finalidad del tratamiento y, cuando
        ya no sea necesario, se suprimirán con medidas de seguridad adecuadas. Los datos podrán conservarse durante
        los plazos legalmente exigibles.
      </p>

      <H>5. Destinatarios</H>
      <p>
        No se cederán datos a terceros salvo obligación legal. Para la prestación del servicio podemos utilizar
        proveedores tecnológicos (alojamiento web y envío de correos electrónicos) que actúan como encargados del
        tratamiento bajo las garantías exigidas por el RGPD.
      </p>

      <H>6. Derechos del usuario</H>
      <p>
        Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y
        portabilidad de los datos dirigiéndote al responsable a través de los canales de contacto de la web. Asimismo,
        tienes derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).
      </p>

      <H>7. Medidas de seguridad</H>
      <p>
        El responsable adopta las medidas técnicas y organizativas necesarias para garantizar la seguridad,
        confidencialidad e integridad de los datos personales, evitando su alteración, pérdida, tratamiento o acceso
        no autorizado.
      </p>
    </LegalLayout>
  );
}
